<script>

import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MoneyBackGuaranteed',
  computed: {
    ...mapState('benefits', ['benefitId']),
    ...mapGetters('subscriptionState', ['inTrial', 'hasMoneyBackOffer', 'showMbgPopup']),
    ...mapGetters('featureFlags', ['moneyBackGuaranteeIsOn']),
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
    eligibleForMoneyBackGuaranteed() {
      return this.moneyBackGuaranteeIsOn && !this.benefitId && !this.eligibleForDiscountPromotion;
    },
  },
};

</script>
